import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useRoute } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoMessage',
  setup(__props) {

const route = useRoute();
const { store } = useContext();

const authUser = computed(() => store.getters['application/driver/authUser']);
const userAlert = computed(() => store.getters['application/driver/userAlert']);

const showUserAlert = computed(() => {
    if (route.value.name === 'metaworld-map') return false;
    return authUser.value && userAlert.value && userAlert.value.isVisible
})

const handleClose = () => {
    store.dispatch('application/driver/clearUserAlert')
}

return { __sfc: true,route, store, authUser, userAlert, showUserAlert, handleClose }
}

})